export const toastrConfig = {
  timeOut: 10000,
  positionClass: 'toast-bottom-right',
  preventDuplicates: true,
};
